module.exports = __webpack_public_path__ + "static/media/FACA Logo.dadd6e58.png";